<ng-container *transloco="let t">
  @if (canDelete) {
    <xi-icon-button
      icon="trash"
      size="small"
      [tooltip]="{ text: t('color-box.delete-color'), direction: 12 }"
      (onClick)="colorDelete.emit()"
      class="color-box__delete-icon"
    ></xi-icon-button>
  }

  <xi-color-picker
    [direction]="6"
    [selectedColor]="rgbaColor"
    (onColorChange)="colorChange$.next($event.detail.color)"
    [class.color-box__color-picker--disabled]="!canEdit"
    class="color-box__color-picker"
  ></xi-color-picker>
</ng-container>
